import { Directive, ElementRef, AfterViewInit } from '@angular/core';

@Directive({
    selector: `[validateCertificateId]`
})
export class ValidateCertificateIdDirective implements AfterViewInit {
    constructor(private elRef: ElementRef) {
    }
    ngAfterViewInit(): void {
        this.elRef.nativeElement.innerText = "Allowed Chars 0-9 a-z A-Z";
        this.elRef.nativeElement.classList.add('validate');
    }
}


// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Common/Directives/validate-certificate-id.directive.ts